// design : https://www.figma.com/design/BdJfkp9ACAlSVToOU8HrfB/%E2%80%94-International-%E2%80%94?node-id=4157-68092&m=dev
export const STATUS_BADGE_COLOR_MAP: Record<
  string,
  'success' | 'warning' | 'error' | 'info'
> = {
  REGISTERED: 'success',
  VERIFIED: 'success',
  VETTED_VERIFIED: 'success',
  COMPLETED: 'success',
  UNVERIFIED: 'warning',
  NOT_SUBMITTED: 'warning',
  NOT_SENT: 'warning',
  EXPIRED: 'error',
  ENDED: 'error',
  VOIDED: 'error',
  DECLINED: 'error',
  PENDING: 'info',
  SENT_FOR_SIGNATURE: 'info',
  SENT: 'info',
  SUSPENDED: 'error',
  // undefined section
  ACTIVE: 'success',
  REVIEW: 'warning',
  REJECTED: 'error',
};
